import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Button, Card, Divider, Typography, Spin } from "antd";
import { CloseOutlined, PicRightOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import useGetApi from "../../services/useGetApi";
import QuizDetailsCard from "../quizResult/QuizDetailsCard";

const { Title, Text } = Typography;

const QuizResultPopup = ({ userId, courseId }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [quizResultBtn, setQuizResultBtn] = useState(false);
  const [isLoading, error, quizResults, getQuizResults] = useGetApi(
    `quizResults/${userId}/${courseId}`,
    [],
    true
  );

  useEffect(() => {
    getQuizResults(`quizResults/${userId}/${courseId}`);
  }, [userId, courseId]);

  return (
    <div>
      {/* Button to Open Popup */}
      <Button
        type="primary"
        shape="circle"
        icon={<PicRightOutlined />}
        onClick={() => setQuizResultBtn(true)}
      />

      {/* Popup Modal */}
      <Modal
        open={quizResultBtn}
        onCancel={() => setQuizResultBtn(false)}
        footer={null}
        width={600}
        centered
        closable={false}
        className="quiz-result-modal"
      >
        {/* Header */}
        <Row justify="space-between" align="middle">
          <Col>
            <h6>Quiz Results</h6>
          </Col>
          <Col>
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => setQuizResultBtn(false)}
            />
          </Col>
        </Row>

        <Divider />

        {/* Loading & Error Handling */}
        {isLoading ? (
          <Spin size="large" />
        ) : error ? (
          <Text type="danger">Error: {error}</Text>
        ) : quizResults && quizResults.length > 0 ? (
          quizResults.map((result, index) => (
            <Card key={index} className="quiz-result-card">
              <QuizDetailsCard
                courseId={courseId}
                sectionId={result?.sectionId}
                quizId={result?.quizId}
              />

              <Row justify="space-between">
                <Col>
                  <Text>
                    <strong>Total Attempts:</strong> {result.noOfAttempts}
                  </Text>
                </Col>
                <Col>
                  <Text>
                    <strong>Marks:</strong> {result.totalObtainedMarks}
                  </Text>
                </Col>
              </Row>

              <Divider />

              <Button
                type="primary"
                block
                onClick={() =>
                 window.location.href = `https://userpanel.taggeo.in/quizresults/course/${id}/section/${result.sectionId}/quiz/${result.quizId}/student/${userId}`
                }
              >
                Go to Answer Sheet
              </Button>
            </Card>
          ))
        ) : (
          <Text>No quiz results found. The quiz may not have been taken yet.</Text>
        )}
      </Modal>
    </div>
  );
};

export default QuizResultPopup;
